import initialState from '../../initialstate';
import * as types from '../../../actions/actiontypes';

export function quickLinkReducer(state = initialState.quickLink, action) {
	switch (action.type) {
		case types.GET_QUICKLINKS_BY_ENGAGEMENTID: {
			return action.response;
		}

		default:
			return state;
	}
}
